import axios from 'axios'
import store from '../store/index'
const url = store.state.Url + ':'
export function requestUrl() {
  return url
}

export function request(config) {
  const request1 = new axios.create({
    baseURL: url + '9007',
    method: 'POST',
    timeout: 10000,
    headers: {
      'content-Type': 'application/json',
    },
  })
  return request1(config)
}
export function requestYSY(config) {
  const request1 = new axios.create({
    baseURL: 'https://open.ys7.com/api/lapp/token/get',
    method: 'POST',
    timeout: 10000,
  })
  return request1(config)
}
export function requestCamera(config) {
  const request1 = new axios.create({
    baseURL: 'https://open.ys7.com/api/lapp/camera/list',
    method: 'POST',
    timeout: 10000,
  })
  return request1(config)
}
export function requestTime(config) {
  const request1 = new axios.create({
    baseURL: 'https://open.ys7.com/api/lapp/video/by/time',
    method: 'POST',
    timeout: 10000,
  })
  return request1(config)
}
export function requestCapture(config) {
  const request1 = new axios.create({
    baseURL: 'https://open.ys7.com/api/lapp/device/capture',
    method: 'POST',
    timeout: 30000,
  })
  return request1(config)
}
export function requestInfo(config) {
  const request1 = new axios.create({
    baseURL: 'https://open.ys7.com/api/lapp/device/info',
    method: 'POST',
    timeout: 10000,
  })
  return request1(config)
}
export function requestArr() {
  var request1 = new axios.create({
    baseURL: url + '9007',
    method: 'POST',
    timeout: 10000,
    headers: {
      'content-Type': 'application/json',
      token: JSON.parse(localStorage.register).data.token,
    },
  })
  return request1
}
export function requestArr1() {
  var request1 = new axios.create({
    baseURL: url + '9004',
    method: 'POST',
    timeout: 30000,
    headers: {
      'content-Type': 'application/json',
      token: JSON.parse(localStorage.register).data.token,
    },
  })
  return request1
}
export function requestArr2() {
  var request1 = new axios.create({
    baseURL: url + '9007',
    method: 'POST',
    timeout: 10000,
    headers: {
      'content-Type': 'application/json',
      token: JSON.parse(localStorage.register).data.token,
    },
  })
  return request1
}
export function requestLogin() {
  var request1 = new axios.create({
    baseURL: url + '9007',
    method: 'POST',
    timeout: 10000,
    headers: {
      'content-Type': 'application/json',
    },
  })
  return request1
}
export function requestArr3() {
  var request1 = new axios.create({
    baseURL: url + '9010',
    method: 'POST',
    timeout: 10000,
    headers: {
      'content-Type': 'application/json',
      token: JSON.parse(localStorage.register).data.token,
    },
  })
  return request1
}
export function requestArr9008() {
  var request1 = new axios.create({
    baseURL: url + '9008',
    method: 'POST',
    timeout: 10000,
    headers: {
      'content-Type': 'application/json',
      token: JSON.parse(localStorage.register).data.token,
    },
  })
  return request1
}
export function requestArr9007() {
  var request1 = new axios.create({
    baseURL: url + '9007',
    method: 'POST',
    timeout: 10000,
    headers: {
      'content-Type': 'application/json',
      token: JSON.parse(localStorage.register).data.token,
    },
  })
  return request1
}

////////////////////////////////////////////////84
export function requestArr84004 () {
  var request1 = new axios.create({
    baseURL: "http://47.110.245.84:9004",
    method: "POST",
    timeout: 10000,
    headers: {
      "content-Type": "application/json",
      "token": JSON.parse(localStorage.register).data.token
    }
  })
  return request1;
}
export function requestArr84 () {
  var request1 = new axios.create({
    baseURL: 'http://47.110.245.84:9004',
    method: "POST",
    timeout: 10000,
    headers: {
      "content-Type": "application/json",
      "token": JSON.parse(localStorage.register).data.token
    }
  })
  return request1;
}
////////////////////////////////////////////////84



// WEBPACK FOOTER //
// ./src/network/request.js